import { Component } from '@angular/core';

@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.component.html',
  styleUrl: './cookies.component.css'
})
export class CookiesComponent {

  cookiePolicy: Number | undefined;

  ngOnInit(): void {
    this.cookiePolicy = +localStorage['cookiePolicy'];
  }

  hideCookies(){
    this.cookiePolicy = 1;
    localStorage.setItem('cookiePolicy', '1');
  }

}
